export enum BrandNames {
  Industrious = 'Industrious',
  WelkinMeraki = 'Welkin & Meraki',
  TheGreatRoom = 'The Great Room',
}
